<script setup>
import { reactiveOmit } from "@vueuse/core";
import { Separator } from "reka-ui";
import { cn } from "@/lib/utils";

const props = defineProps({
  orientation: String,
  decorative: Boolean,
  class: [String, Array, Object],
  label: String,
});

const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <Separator
    v-bind="{ ...delegatedProps, ...$attrs }"
    :class="
      cn(
        'vf-shrink-0 vf-bg-border vf-relative',
        props.orientation === 'vertical'
          ? 'vf-w-px vf-h-full'
          : 'vf-h-px vf-w-full',
        props.class
      )
    "
  >
    <span
      v-if="props.label"
      :class="
        cn(
          'vf-text-xs vf-text-muted-foreground vf-bg-neutral-300 vf-absolute',
          'vf-top-1/2 vf-left-1/2 -vf-translate-x-1/2 -vf-translate-y-1/2 vf-flex vf-justify-center vf-items-center',
          props.orientation === 'vertical'
            ? 'vf-w-[1px] vf-px-1 vf-py-2'
            : 'vf-h-[1px] vf-py-1 vf-px-2'
        )
      "
    >
      {{ props.label }}
    </span>
  </Separator>
</template>
